import { render } from "./ProfitCalculator.vue?vue&type=template&id=422dd05c&scoped=true"
import script from "./ProfitCalculator.vue?vue&type=script&lang=js"
export * from "./ProfitCalculator.vue?vue&type=script&lang=js"

import "./ProfitCalculator.vue?vue&type=style&index=0&id=422dd05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422dd05c"]])

export default __exports__